import React from 'react'
import PropTypes from 'prop-types'
import { DateTime } from 'luxon'
import { Card, CardContentLoader } from '../../Card/Card'
import Dollars from '../../Dollars/Dollars'
import cx from 'classnames'

import AddToCart from '../../../assets/add-to-cart.svg'
import { ReorderButton } from '../ReorderButton/ReorderButton'
import { useAvailability } from '../../../utils/availability'
import { sumByField, joinFieldByCommas } from '../../../utils/reducer-utils'

import './ReorderCard.css'

export const ReorderCard = ({
  loading = false,
  items = [],
  date,
  price = 0,
  orderGuid,
  hideOnMobile = false
}) => {
  const { orderingAvailable, loading: availabilityLoading } = useAvailability()
  const itemsText = joinFieldByCommas('name')(items)
  const itemQuantity = sumByField('quantity')(items)

  const disableReorder = availabilityLoading || !orderingAvailable

  return (
    <li
      data-testid='reorder-card'
      key={orderGuid}
      styleName={cx('orderCardContainer', { hideOnMobile })}
    >
      <Card
        loading={loading}
        endAdornment={(
          <ReorderButton orderGuid={orderGuid} disabled={disableReorder}>
            <AddToCart />
          </ReorderButton>
        )}
        loadingSkeleton={<CardContentLoader height={58} />}
      >
        <div styleName='orderContent'>
          <h3 styleName='orderHeader'>{itemsText}</h3>
          <div styleName='orderSubHeader'>
            <span>
              <Dollars amount={price} />
            </span>
            <span styleName='orderDetailsQuantity'>{itemQuantity} Item{itemQuantity > 1 ? `s` : ''}</span>
            <span styleName='orderDate'>
              {DateTime.fromMillis(date).toLocaleString({
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
              })}
            </span>
          </div>
        </div>
      </Card>
    </li>
  )
}

const itemShape = PropTypes.shape({
  name: PropTypes.string
})

ReorderCard.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(itemShape).isRequired,
  date: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  hideOnMobile: PropTypes.bool,
  orderGuid: PropTypes.string.isRequired
}
